// 手数与份额换算比例 1手=1份
export const NUM_RATIO = 1;
// 默认产品发行价格
export const DEFAULT_PRODUCT_PRICE = 1;

/**
 * 数据太小时的基数*1000
 * @type {{unit: string; base: number}}
 */
export const DATA_BASE = {
  // 单位：千
  unit: '千',
  // 基数
  base: 1000,
};

// 产品类型
export enum ProductTypeEnum {
  // 10. DRO
  DRO = 1,
  // 20. DRP
  DRP = 2,
}

// DRO类型
export enum DROTypeEnum {
  ALL = 8,
  // 待开发申购
  WAITING = 0,
  // Io
  IO = 1,
  // Ao
  AO = 2,
  // so
  SO = 3,
}

export const ProductStatusTransKeyMap = {
  [DROTypeEnum.IO]: 'common.purchasing',
  [DROTypeEnum.AO]: 'common.purchasing',
  [DROTypeEnum.SO]: 'common.trading',
};

// 账户详情分类
export enum AccountDetailTypeEnum {
  // 账户变动明细
  ACCOUNT_CHANGE_DETAIL = '1',
  // 账户清单
  ACCOUNT_LIST = '2',
}

export const LastDateKey = 'querylastDate';

// 资金类型
export enum fundTypeEnum {
  //1. 现金转入（针对0号方案对应的资金转入）
  FUND_IN = 1,
  //2. 现金提取（针对会员成功提取资金，出金）
  FUND_OUT = 2,
  //3. DRO申购（针对AO交易对应的买方资金划扣，出金）
  DRO_SUBSCRIBE = 3,
  //4. DRO买入（针对SO交易对应的买方资金划扣，出金）
  DRO_BUY = 4,
  //5. DRO卖出（针对SO卖出，入金）
  DRO_SELL = 5,
  //6. 收入分成（针对持仓DRO的每日收入分成，扣税扣费，入金
  INCOME_DIVISION = 6,
  //7. 账户结息（针对会员现金存在滴灌通账户的利息，入金）
  ACCOUNT_INTEREST = 7,
  //8. 资产生成费（AO全部申购、部分成功，出金）
  ASSET_GENERATION = 8,
  //9. 撮合交易费（SO全部、部分成功，出金）
  MATCHING_TRANSACTION = 9,
  //10. DRO服务费（每日收入分成中扣除的DRO服务费，出金）
  DRO_SERVICE = 10,
  //11. 确钱交收费（每日收入分成中扣除的ARM费用，出金）
  ARM_FEE = 11,
  //12. 账户间划拨（母子交易账户之间划拨资金，出金、入金均有）
  ACCOUNT_TRANSFER = 12,
}

// 业务类型
export enum businessTypeEnum {
  // 1. 现金转入
  CASH_IN = 1,
  // 2. 现金提取
  CASH_OUT = 2,
  // 3. 收入分成
  INCOME_DIVISION = 3,
  // 4. 资金划拨
  FUND_TRANSFER = 4,
  // 5. AO买入
  AO_BUY = 5,
  // 6. SO买卖
  SO_BUY_SELL = 6,
}

export enum DirectuinEnum {
  // 收入
  INCOME = 0,
  // 支出
  EXPENDITURE = 1,
}

export enum HasCollectEnum {
  // 未自选
  No = 0,
  // 自选
  Yes = 1,
}

export enum TradingAccountLevelEnum {
  MAIN = 0, // 父账户(主账户)
  SUBORDINATE = 1, // 子账户
}

export enum orderStatusEnum {
  // -1:下单失败
  FAIL = -1,

  // 0:下单中,未能确定下单结果，需找交易所处理
  PENDING = 0,

  // 1:下单成功
  WAITING = 1,

  // 2:部分成交
  PARTIAL = 2,

  // 3:全部成交
  SUCCESS = 3,

  // 4:未成交
  FAIL_MATCH = 4,

  // 5:订单取消
  CANCELLED = 5,
}

export enum orderDirectionEnum {
  // 1:买入
  BUY = 1,
  // 0:卖出
  SELL = 0,
}

// 账户状态
export enum AccountStatusEnum {
  // 0:正常
  NORMAL = 0,
  // 1:注销
  CANCEL = 1,
  // 2:开通中
  OPENING = 2,
  // 3:开通失败
  OPEN_FAIL = 3,
}

// 转账状态
export enum TransferStatusEnum {
  // 0:成功
  SUCCESS = 0,
}

// 显示类型
export enum ShowTypeEnum {
  // 卡片
  CARD = 1,
  // 列表
  LIST = 2,
}

// 地区类型
export enum AreaTypeEnum {
  // 省
  PROVINCE = 1,
  // 市
  CITY = 2,
  // 区
  AREA = 3,
}

// IndustryLevelTypeEnum
export enum IndustryLevelTypeEnum {
  // 行业
  INDUSTRY = 1,
  // 业态
  FORMAT = 2,
  // 品类
  CATEGORY = 3,
}

// 开店类型
export enum ShopTypeEnum {
  // 直营
  DIRECT = 1,
  // 加盟
  FRANCHISED_OUTLET = 2,
}
export const ShopTypeOptions = [
  {
    value: ShopTypeEnum[ShopTypeEnum.DIRECT],
    label: '直营',
  },
  {
    value: ShopTypeEnum[ShopTypeEnum.FRANCHISED_OUTLET],
    label: '加盟',
  },
];

// 结算行账号状态
export enum SettlementAccountStatusEnum {
  // -1:无效
  INVALID = -1,
  // 0:有效
  VALID = 0,
  // 1:审核驳回
  REJECT = 1,
  // 2:审核拒绝
  REFUSE = 2,
  // 3:处理中
  PROCESSING = 3,
  // 4:注销中
  CANCELING = 4,
  // 5:已注销
  CANCELED = 5,
}

// 分红频率
export enum DividendFrequencyEnum {
  // 1:每日
  DAILY = 1,
  // 2:每周
  WEEKLY = 2,
  // 3:每月
  MONTHLY = 3,
}

// 申购单位
export enum UnitEnum {
  // 1:份
  SHARES = 1,
  // 2:手
  HAND = 2,
}

// 产品状态
export enum ProductStatusEnum {
  // 失效
  INVALID = -1,
  // 未开放=>待开放申购
  NOT_OPEN = 0,
  // 开放
  OPEN = 1,
  // 暂停
  SUSPEND = 2,
  // 结束
  END = 3,
}

/**
 * 交易方向
 */
export enum TransactionDirectionEnum {
  // 1 卖出
  EXPENDITURE = 1,
  // 0 买入
  INCOME = 0,
}

/**
 * 充值提现类型
 * 1. 充值
 * 2. 提现
 * 3. 划拨
 **/
export enum RechargeWithdrawalTypeEnum {
  // 1 充值
  RECHARGE = 1,
  // 2 提现
  WITHDRAWAL = 2,
  // 3 划拨
  TRANSFER = 3,
}

/**
 * 结单类型
 */
export enum SettlementTypeEnum {
  // 1. 月结单
  MONTHLY = 1,
  // 2. 日结单
  DAILY = 2,
}

// 现金流类型
export enum CashFlowTypeEnum {
  /**
   * 1: 当日现金流
   */
  CURRENT_CASH_FLOW = 1,
  /**
   * 2:累计历史现金流/累计基准现金流
   */
  ACCUMULATED_CASH_FLOW = 2,
  /**
   * 3:剩余基准现金流
   */
  REMAINING_CASH_FLOW = 3,
  /**
   * 4:滴灌额/基准千元日回款
   */
  ACCOUNTING_THOUSAND_DAY_REPAYMENT = 4,
}

// 历史现金流 过去90天 过去30天 过去7天 累计历史现金流；基准现金流 未来90天 未来30天 未来7天 剩余基准现金流;
export enum CashFlowTimeTypeEnum {
  // 过去90天
  PAST_90_DAYS = 1,
  // 过去30天
  PAST_30_DAYS = 2,
  // 过去7天
  PAST_7_DAYS = 3,
  // 未来90天
  FUTURE_90_DAYS = 4,
  // 未来30天
  FUTURE_30_DAYS = 5,
  // 未来7天
  FUTURE_7_DAYS = 6,
  // 累计历史现金流
  ACCUMULATED_CASH_FLOW = 7,
  // 剩余基准现金流
  REMAINING_CASH_FLOW = 8,
}

/**
 * 行情类型
 */
export enum MarketTypeEnum {
  // 1. 今日行情
  TODAY = 1,
  // 2. 历史行情
  HISTORY = 2,
  // 3. 价格走势
  PRICE_TREND = 3,
}

/**
 * drp申购交易类型
 */
export enum DrpTransactionTypeEnum {
  // 0. 首次发行买入
  FIRST_ISSUE_BUY = 0,
  // 1. 循环投资买入
  RECURRING_INVESTMENT_BUY = 1,
}

// 导出类型
export enum ExportTypeEnum {
  // 1. 持仓
  HOLDING = 1,
}

// 导出状态
export enum ExportStatusEnum {
  // 0 导出中，1 导出成功，-1 导出失败
  PENDING = 0,
  SUCCESS = 1,
  FAIL = -1,
}

// 币种类型
export enum CurrencyTypeEnum {
  RMB = 'RMB',
  MOP = 'MOP',
}

// 收益类型
export enum IncomeTypeEnum {
  /**
   * 利息--Interest
    本金--Principal
    超额收入--Return
    现金流--Cashflow 
   */
  INTEREST = 'Interest',
  PRINCIPAL = 'Principal',
  EXCESS_INCOME = 'Return',
  CASH_FLOW = 'Cashflow',
}

export enum BusinessTypeEnum {
  // 1. 持仓导出
  CERTIFICATE_BOOK = 1,
  // 2. dro收益记录
  DRO_INCOME_RECORDS = 2,
  // 3. drp收益记录
  DRP_INCOME_RECORDS = 3,
}

export enum BatchTransactionTypeEnum {
  // 固定目标申购金额，按挂牌金额比例下单
  FIXED_TARGET_SUBSCRIBE = 1,
  // 等份额下单
  EQUAL_SHARES = 2,
  // 固定申购比例下单
  FIXED_SUBSCRIBE_RATIO = 3,
  // 自定义
  CUSTOM = 4,
}

/**
 * 新增结算账户步骤
 */
export enum AddSettlementAccountStepEnum {
  // 1. 选择入金方案
  SELECT_DEPOSIT_SCHEME = 1,
  // 2. 填写资料
  FILL_IN_INFORMATION = 2,
}

/**
 * 入金方案
 */
export enum DepositSchemeEnum {
  /**
   * A.汇丰香港
   */
  HSBC_HK = 'A',
  /**
   * B.汇丰澳门&中银澳门
   */
  HSBC_MO = 'B',
  /*
   *C.于澳门地区开户
   */
  OPEN_ACCOUNT_IN_MO = 'C',
}

/**
 * 挂牌状态
 */
export enum ListingStatusEnum {
  // 0. 挂牌
  LISTED = 0,
  // 1. 停牌
  NOT_LISTED = 1,
  // 2. 摘牌
  DE_LISTED = 2,
}

/**
 * 联营状态
 */
export enum JointOperationStatusEnum {
  // 0. 未联营
  NOT_JOINT = 0,
  // 1. 联营中
  JOINT = 1,
  // 2. 结束联营
  END_JOINT = 2,
}
